module.exports = __webpack_public_path__ + "static/media/page-break.f940e488.svg";